module.exports = __webpack_public_path__ + "img/total_value_icon.png";